import type { ReactNode } from 'react'
import React from 'react'

import { Footer } from 'Footer'
import { Header } from 'Header'

type FullPageProps = {
  children: ReactNode
  route: {
    props: {
      footerIsOnLandingPage: boolean
      showHeaderWithoutNavLink?: boolean
      hasLoginModal?: boolean
    }
  }
}
export const FullPage = ({
  children,
  route: {
    props: { footerIsOnLandingPage, showHeaderWithoutNavLink = false, hasLoginModal = false },
  },
}: FullPageProps) => (
  <>
    <Header simple={showHeaderWithoutNavLink} hasLoginModal={hasLoginModal} />
    {children}
    <Footer copyright isOnLandingPage={footerIsOnLandingPage} />
  </>
)
